<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/wuhou/2/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为深入贯彻党的二十大精神，全面落实新时代人才工作新理念新战略新举措，认真贯彻中央和省委、市委人才工作会议精神，深入实施人才强区战略，充分发挥市场主体作用，赋予链主企业、国家级创新平台、国家级领军人才等人才自主推荐权，全面提升人才自主培育质量，培育壮大本土优秀人才队伍，为创建区域创新人才高地特色区提供坚实的人才支撑。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/1/title1.png" alt="" />
          <div class="content">
            <div class="commonCircle">
              <div
                class="commonCircle-circle"
                style="margin-right: 0.15rem"
              ></div>
              <div class="commonCircle-font">基本条件：</div>
            </div>
            <div class="des" style="margin-top: 0.1rem">
              <div>
                （一）产业优秀人才支持范围为符合武侯区重点产业领域发展方向，在相关领域有突出贡献的优秀人才；
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）产业优秀人才要求在武侯区企业连续工作5年以上的全职在岗人员（新引进的招才引智企业（项目）除外）；
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）申报的企业应依法在武侯区履行纳税或统计义务，工商注册、税务登记和统计关系原则上均应在武侯区，主营业务应为武侯区重点产业领域，无重大违规违法行为和严重失信行为。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/1/title2.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.1rem">
              <div>（一）授予产业优秀人才入选者“诸葛优才”的荣誉证书。</div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）产业优秀人才的资助资金，一次性拨付。其中，链主企业推荐的产业优秀人才，给予5万元资助奖励；国家级创新平台推荐的产业优秀人才，给予5万元资助奖励；领军人才举荐的产业优秀人才，给予国家级人才推荐人选10万元资助奖励，给予省级人才推荐人选2万元资助奖励。对新引进的市级招才引智类高能级项目，给予企业（项目）核心人才团队一次性20万元奖励。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）资助奖励主要用于科技研发、课题研究、交流培训、团队建设、成果转化、市场推广等，可适当用于改善入选人员工作生活条件。
              </div>
            </div>
            <div style="color: #0839b7; font-size: 0.26rem; text-align: left;margin-top: 0.2rem;line-height: 0.44rem;">
              认定的人才除享受相应奖励补贴以外，还享受落户、住房安居、医疗保健、出入境和停居留等服务保障。
            </div>
          </div>
        </div>
        <div class="part-four">
          <img
            src="../../assets/imgs/wuhou/1/title3.png"
            class="part-two-title-img"
          />
          <div class="main-content">
            <div class="part-four-items">
              <div class="title-bg">制发通知</div>
              <div class="part-four-content1">
                区委组织部（区委人才办）每年度制发申报通知，明确遴选工作的标准条件、申报程序、时间进度等。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">推荐申报</div>
              <div class="part-four-content1">
                <div>
                  在重点产业链链主企业、重点企业国家级创新平台、领军人才、招才引智企业（项目）中开展分类推荐。具体如下：
                </div>
                <div
                  style="
                    font-size: 0.26rem;
                    color: #333;
                    margin: 0.2rem 0;
                    font-weight: 600;
                  "
                >
                  第一类：链主企业
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                    >（1）确定自评企业。</span
                  >
                  各重点产业链牵头部门制定自评企业资格标准，确定具有推荐权的自评企业名单，每个产业链推荐1家自评企业。
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                    >（2）开展企业自评。</span
                  >
                  每家自评企业结合单位人才技术水平、业绩成果和经济社会贡献等方面进行评选，在本单位确定1名初评人选，初评人选原则上应为企业有突出贡献的科技创新人才。
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                    >（3）提交初评人选。</span
                  >
                  自评企业确定初评人选并公示后，报重点产业链牵头部门，牵头部门汇总审核后报区委组织部（区委人才办）。
                </div>
                <div
                  style="
                    font-size: 0.26rem;
                    color: #333;
                    margin: 0.2rem 0;
                    font-weight: 600;
                  "
                >
                  第二类：国家级创新平台
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                  >
                    （1）确定推荐主体。</span
                  >
                  区经科信局明确具有推荐权的国家级创新平台名单，包含但不限于国家产业创新中心、国家制造业创新中心、国家技术创新中心、国家工程研究中心、国家企业技术中心等，且应为依托武侯区企业组建。
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                    >（2）开展平台自评。</span
                  >
                  国家级创新平台结合单位人才技术水平、业绩成果和经济社会贡献等方面开展内部评选，每个平台可推荐1名初评人选。
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                  >
                    （3）提交初评人选。</span
                  >
                  国家级创新平台确定初评人选并公示后，向区经科信局申报，区经科信局汇总审核后报区委组织部（区委人才办）。
                </div>
                <div
                  style="
                    font-size: 0.26rem;
                    color: #333;
                    margin: 0.2rem 0;
                    font-weight: 600;
                  "
                >
                  第三类：领军人才
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                  >
                    （1）确定推荐主体。</span
                  >
                  区委组织部（区委人才办）明确具有推荐权的专家人才名单，专家人才分为国家级（国家高层次人才特殊支持计划、国家海外高层次人才引进计划的入选者）和省级（天府峨眉计划、天府青城计划入选者），专家人才工作关系应在武侯区企业。
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                  >
                    （2）领军人才推荐。</span
                  >
                  专家人才在领衔技术团队里开展内部推荐，确定1名初评人选后，经专家人才所在企业研究同意并公示后，报区委组织部（区委人才办）。
                </div>
                <div
                  style="
                    font-size: 0.26rem;
                    color: #333;
                    margin: 0.2rem 0;
                    font-weight: 600;
                  "
                >
                  第四类：招才引智企业（项目）
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                  >
                    （1）认定条件。</span
                  >
                  高能级项目应符合《成都市新引进重大项目和高能级项目认定办法》（成开放领办〔2022〕2号）中招才引智类高能级项目标准要求，“双招双引”专家团队应符合《成都市“双招双引”顶尖科技创新团队支持办法》（成人才办〔2022〕1号）标准要求，并经市投促局认定。
                </div>
                <div>
                  <span
                    style="font-size: 0.26rem; color: #333; font-weight: 600"
                  >
                    （2）确定初评人选。</span
                  >
                  区投促局根据上一年度项目落地情况，确定符合条件的招才引智类高能级项目，每个高能级项目确定1名核心人才，区投促局会同相关单位并对企业（项目）情况、团队核心人才条件进行审核后，报区委组织部（区委人才办）。
                </div>
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">联审</div>
              <div class="part-four-content1">
                区委组织部（区委人才办）会同相关部门进行联合审核，根据部门联审意见，提出产业优秀人才建议人选。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg4">审定</div>
              <div class="part-four-content1">
                区委组织部（区委人才办）将产业优秀人才建议人选报经区委组织部部务会审定，审定通过后确定拟奖励资助人选。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg5">公示及实施</div>
              <div class="part-four-content1">
                拟资助奖励人选公示5个工作日。公示期满无异议，由区委组织部（区委人才办）办理资金拨付手续。
              </div>
            </div>
          </div>
          <div
            style="
              color: #0839b7;
              font-size: 0.26rem;
              text-align: left;
              margin-top: -0.4rem;
              margin-bottom: 0.3rem;
              line-height: 0.44rem;
            "
          >
            已评为武侯区产业领军人才和武侯区产业优秀人才的人才，不得再次申报武侯区产业优秀人才奖。同时符合多个类型推荐条件的，仅能选择一种类型，不得多个类型同时推荐。
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="../../assets/imgs/wuhou/1/title4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-85563179">028-85563179</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              武侯区委人才办
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="info" src="../../assets/imgs/147/code.png" />
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.commonCircle {
  display: flex;
  align-items: center;
  margin: 0.19rem 0;
  &-circle {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
  }
  &-font {
    font-size: 0.34rem;
    color: #333;
    font-weight: 600;
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    // height: 4.73rem;
  }

  .technological-process {
    transform: translateY(-2.5rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
